import _ from 'lodash';
import AssignmentsService from '../assignments/assignments.service';

class TableGridDropdownCellController {
  constructor($scope) {
    this.scope = $scope;
    this.name = 'tableGridDropdownCell';
    this.config = {checkBoxes: true, idProperty: 'id', displayProp: 'name'};
    this.textConfig = {
      checkAll: 'All Schools', 
      dynamicButtonTextSuffix: 'school',
      buttonDefaultText: 'NO SCHOOLS'
    };
    this.rowId = null;
    this.rowSchoolIds = null;
    this.schoolList = [];
    this.selectedItem = [];
    this.assignmentsService = new AssignmentsService();
    this.eventConfig = this.addEvents();
    this.watchRowSelection();
  }

  addEvents() {
    return {
      onItemSelect: this.onItemAdded.bind(this), 
      onItemDeselect: this.onItemDeleted.bind(this), 
      onSelectAll: this.onItemAdded.bind(this), 
      onDeselectAll: this.onItemDeleted.bind(this) 
    };
  }

  buildSchoolList() {
    let list = _.cloneDeep(this.scope.metaData.entitler.schoolList);
    const isRestricted = this.scope.row.isSecondaryProduct && !this.scope.row.isConnectEdProduct;
    const eligibleSchoolIds = this.getEligibleSchoolIds();
    list.forEach(e => {
      e.disabled = isRestricted && !eligibleSchoolIds.includes(e.id);
      return e;
    });
    this.cacheEnabledSchools(list);
    return list;
  }

  // Cache the enabled schools for this row so that submitSelections() can
  // determine "all schools" using the same criteria used to build this
  // dropdown, even after the row falls out of the currently loaded page
  // (e.g. after a search or sort reload).
  cacheEnabledSchools(list) {
    const entitler = this.scope.metaData.entitler;
    entitler.rowEnabledSchoolIds = entitler.rowEnabledSchoolIds || {};
    entitler.rowEnabledSchoolIds[this.scope.row.id] = list
      .filter(item => !item.disabled)
      .map(item => item.id);
  }

  getEligibleSchoolIds() {
    const schoolIds = this.scope.row.schoolIdsfromProductAssociation || [];
    const allSchoolIds = _.map(this.scope.metaData.entitler.schoolList, 'id');

    if (!this.scope.row.isSecondaryProduct || this.scope.row.isConnectEdProduct) {
      return allSchoolIds;
    }

    if (schoolIds.length > 0 || !this.scope.row.allSchoolsfromProductAssociation) {
      return schoolIds;
    }

    return allSchoolIds;
  }

  getSelectableSchools() {
    return this.schoolList.filter(school => !school.disabled);
  }

  shouldSelectAllSchools() {
    return this.scope.row.productAssignmentType === 'OR' || this.scope.row.allSchools;
  }

  watchRowSelection() {
    this.scope.$watchCollection('row.isSelected', this.updateSchoolSelect.bind(this), true);
  }

  updateSchoolSelect (newValue) {
    if(!this.scope.row || !angular.isDefined(newValue)){
      return;
    }
    this.rowId = this.scope.row.id;
    this.rowSchoolIds = this.scope.row.schoolIds;

    if(newValue && this.schoolList.length === 0) {
      this.schoolList = this.buildSchoolList();
    }

    if(newValue) {
      const createMetaDataValues = this.scope.metaData.entitler.schoolMappingCreated[this.rowId];
      const deleteMetaDataValues = this.scope.metaData.entitler.schoolMappingDeleted[ this.rowId ];
      if (this.rowSchoolIds.length === 0 && !this.scope.row.isAssigned) {
        // check for metaDataValue in create or deleted for value change which are still local when the UI is re-draw (ie. sorting or search);
        if(createMetaDataValues || deleteMetaDataValues){
          // remove items from createMetaValues; to display selection
          let newSelectedSchoolIds = _.difference(createMetaDataValues, deleteMetaDataValues);
          this.selectedItem = this.shouldSelectAllSchools() ? this.getSelectableSchools() : this.defaultSelectedItem(newSelectedSchoolIds, this.schoolList);
          this.scope.row.hasSchoolFilterChanged = true;
        } else {
          if (this.shouldSelectAllSchools()) {
            this.selectedItem = this.getSelectableSchools();
            this.onItemAdded();
          } else if (this.scope.metaData.persistStudentValue && this.scope.metaData.persistStudentValue.length) {
            this.selectedItem = this.schoolList.filter(school => {
              return !school.disabled && this.scope.metaData.persistStudentValue.indexOf(school.id) !== -1;
            });
            this.selectedItem.forEach((item) => {
              this.onItemAdded(item);
            });
          } else {
            this.selectedItem = this.getSelectableSchools();
            this.onItemAdded();
          }
        }
      } else {
        // check for metaDataValue in create or deleted for value change which are still local when the UI is re-draw (ie. sorting or search);
        if(createMetaDataValues || deleteMetaDataValues){
          // remove items from rowSchoolId; then check for created item, to add them.
          let newSelectedSchoolIds = _.union(deleteMetaDataValues, createMetaDataValues);
          const deletedSchoolIds = _.difference(newSelectedSchoolIds, deleteMetaDataValues);
          if (deletedSchoolIds && deletedSchoolIds.length) {
            this.scope.metaData.entitler.schoolMappingDeleted[ this.rowId ] = deletedSchoolIds;
          } else {
            delete this.scope.metaData.entitler.schoolMappingDeleted[ this.rowId ];
          }
          this.selectedItem = this.shouldSelectAllSchools() ? this.getSelectableSchools() : this.defaultSelectedItem(newSelectedSchoolIds, this.schoolList);
          this.scope.row.hasSchoolFilterChanged = true;
        } else {
          this.selectedItem = this.shouldSelectAllSchools() ? this.getSelectableSchools() : this.defaultSelectedItem(this.rowSchoolIds, this.schoolList);
        }
      }
    } else {
      this.selectedItem = [];
      if(this.rowSchoolIds.length === 0){
        this.scope.row.hasSchoolFilterChanged = false;

        delete this.scope.metaData.entitler.schoolMappingCreated[this.rowId];
        delete this.scope.metaData.entitler.schoolMappingDeleted[this.rowId];
      } else {
        this.scope.metaData.entitler.schoolMappingDeleted[this.rowId] = this.rowSchoolIds;
      }
    
    }
  }

  
  defaultSelectedItem(orgIds, schoolList) {
    return schoolList.filter(item => {
      return orgIds.indexOf(item.id) !== -1;
    }) || [];
  }
 

  // on item added
  onItemAdded (item) {
    let createArray = this.scope.metaData.entitler.schoolMappingCreated;
    let delArray = this.scope.metaData.entitler.schoolMappingDeleted;

    // this might have duplication entries as we dont check the user action here
    if(item) {
      let studentIds = this.updateMetadata(item.id, 'add');
      this.assignmentsService.setPersistValueToLocalStorage(this.scope.metaData.customerId, studentIds);
      const pos = delArray[this.rowId] ? delArray[this.rowId].indexOf(item.id) : -1 ;
      if(pos > -1 ) {
        delArray[this.rowId].splice(pos, 1);
        if(delArray[this.rowId].length === 0 ) {
          delete delArray[this.rowId];
        }
      } else {
        this.scope.row.hasSchoolFilterChanged = true;

        createArray[this.rowId] = Array.isArray(createArray[this.rowId]) ? createArray[this.rowId].concat(item.id) : [item.id];
      }
    } else {
      this.scope.row.hasSchoolFilterChanged = true;

      createArray[this.rowId] =  this.schoolList
        .filter(i => this.rowSchoolIds.indexOf(i.id) === -1 && !i.disabled)
        .map(i => i.id);
    }
  }

  updateMetadata(id, type){
    if (type === 'add') {
      var storedStudentPersistData = JSON.parse(localStorage.getItem(
        "StudentPersistentValue"
      ));
      this.scope.metaData.persistStudentValue = storedStudentPersistData && storedStudentPersistData[this.scope.metaData.customerId] && [...new Set([...storedStudentPersistData[this.scope.metaData.customerId], id])];
      return this.scope.metaData.persistStudentValue;
    }
    if (!(this.scope.metaData.persistStudentValue && this.scope.metaData.persistStudentValue.length)) {
      this.scope.metaData.persistStudentValue = [];
      this.schoolList.filter(school => { if (school.id != id) this.scope.metaData.persistStudentValue.push(school.id) });
      return this.scope.metaData.persistStudentValue;
    }
    this.scope.metaData.persistStudentValue.splice(this.scope.metaData.persistStudentValue.indexOf(id), 1);
    if (this.scope.metaData.persistStudentValue && this.scope.metaData.persistStudentValue.length) {
      return this.scope.metaData.persistStudentValue;
    }
    return [];
  }

  // on item deleted
  onItemDeleted(item){
    if (!this.scope.metaData.entitler.rowIds.includes(this.rowId)){
      this.scope.metaData.entitler.rowIds.push(this.rowId)
    }
    let delArray = this.scope.metaData.entitler.schoolMappingDeleted;
    let createArray = this.scope.metaData.entitler.schoolMappingCreated;

    if(item) {
      let studentIds = this.updateMetadata(item.id, 'remove');
      this.removePersistValueFromLocalStorage(studentIds);
      const pos = createArray[this.rowId] ? createArray[this.rowId].indexOf(item.id) : -1;
      if(pos > -1 ){
        createArray[this.rowId].splice(pos, 1);
        if(createArray[this.rowId].length === 0 ) {
          this.scope.row.hasSchoolFilterChanged = false;
          delete createArray[this.rowId];
        }
      } else {
        this.scope.row.hasSchoolFilterChanged = true;
        delArray[this.rowId] = Array.isArray(delArray[this.rowId]) ? delArray[this.rowId].concat(item.id) : [item.id];
      }
    } else {
      this.schoolList.forEach(school => {
        let studentIds = this.updateMetadata(school.id, 'remove');
        this.removePersistValueFromLocalStorage(studentIds);
      })
      // since the uncheck all will only be called when all items r selected, we just clean the createArray.
      this.scope.row.hasSchoolFilterChanged = true;
      if(createArray[this.rowId]) {
        this.scope.row.hasSchoolFilterChanged = false;

        delete createArray[this.rowId];
        if( this.rowSchoolIds.length > 0) {
          delArray[this.rowId] = this.rowSchoolIds;
        }
      } else {
        this.scope.row.hasSchoolFilterChanged = false;

        delArray[this.rowId] =  this.schoolList
          .filter(i => !i.disabled)
          .map(i => i.id);
      }
    }
  }

  removePersistValueFromLocalStorage(studentIds) {
    var storedStudentPersistData = JSON.parse(localStorage.getItem(
      "StudentPersistentValue"
    ));
    if (storedStudentPersistData) {
      storedStudentPersistData[this.scope.metaData.customerId] = studentIds;
      localStorage.setItem(
        "StudentPersistentValue",
        JSON.stringify(storedStudentPersistData)
      );
    } else {
      let persistValue = {};
      persistValue[this.scope.metaData.customerId] = studentIds
      localStorage.setItem("StudentPersistentValue", JSON.stringify(persistValue));
    }
  }

}

TableGridDropdownCellController.$inject = ['$scope'];

export default TableGridDropdownCellController;



// WEBPACK FOOTER //
// ./app/components/tableGridDropdownCell/tableGridDropdownCell.controller.js